import React from "react";
import "./style.scss";

const Spinner: React.FC = () => {
  return <div className="loading-content" />;
};

export default Spinner;
